import style from "./DeskTopProductDetail.module.scss";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import NiceModal from "@ebay/nice-modal-react";
import { addCommas, clone, decode, rpad2D } from "shared/utils/Utils";
import { requester, storeRequester } from "App";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import { ReactComponent as DummyQr } from "resources/img/dummyQr.svg";
import Flex from "layouts/flex/Flex";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Inline from "layouts/container/Inline";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import initialSearchCondition from "InitialData/InitialSearchCondition.json";
import InputNumber from "components/inputs/InputNumber";
import Container from "layouts/container/Container";
import cartIcon from "resources/img/cartIcon.svg";
import { getCookie } from "shared/StoreRequester";
import { toast } from "react-toastify";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import Dummy from "components/Dummy";
import { renderPriceInline } from "shared/utils/Utils";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import ProductCard from "components/card/product/ProductCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight, faCancel, fas, faShoppingCart, faXmark } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import HighlightedText from "components/inputs/HighlightedText";
import { RegionContext } from "providers/RegionProvider";
import { QRCodeSVG } from "qrcode.react";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { useSelector } from "react-redux";


function DeskTopProductDetail3() {
  const { isMobile } = useContext(BrowserDetectContext);
  const dispatch = useDispatch();
  const { userName } = useContext(AuthContext);
  const { id } = useParams();
  const [product, setProduct] = useState();
  const [slideProduct, setSlideProduct] = useState();
  const [mainImage, setMainImage] = useState("");
  const { t } = useTranslation();
  const inputs = useRef({});
  const isLoading = useSelector((state) => state.history.isLoading);
  const [items, setItems] = useState([]);
  const [isIncrease, setIsIncrease] = useState(false);
  const [paymentResult, setPaymentResult] = useState();
  // const [quantity, setQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0); // 총 금액 상태
  const [selectedRows, setSelectedRows] = useState([]); // 선택된 row 상태
  const { regionId } = useContext(RegionContext);
  const [cartItems, setCartItems] = useState([]);

  const [interests, setInterests] = useState([]);
  const [qrCodeData, setQrCodeData] = useState();

  const isProductWished = product?.id && interests.some(interest => interest.product_id === product.id);
  // const isProductWished = null;

  useEffect(() => {
    const fetchCart = async () => {
      const { cart } = await storeRequester.getMyCart(regionId);
      setCartItems(cart?.items || []);
    };
    fetchCart();
  }, [regionId]);

  useEffect(() => {
    if (inputs.current.length > 0) {
      inputs.current.forEach((input, index) => {
        const value = input?.getValue ? input.getValue() : null;

        if (value !== 0) {
          setItems((prevItems) => {
            const updatedItems = prevItems.map((item) =>
              item.index === index ? { ...item, quantity: value } : item
            );
            return updatedItems;
          });
        } else {
          setItems((prevItems) =>
            prevItems.filter((item) => item.index !== index)
          );
        }
      });
    }
  }, [inputs.current, isIncrease]);
  useEffect(() => {

    let searchCondition = clone(initialSearchCondition);
    searchCondition.productId = id;

    // if (id.startsWith("prod")) {
    storeRequester.getProduct(
      id,
      {
        expand: "images",
        // with_price: true,
        type: "main",
      },
      // ({ product }) => setProduct(product)
      ({ product }) => {

        setSlideProduct(rpad2D(product.variants, (isMobile ? 3 : 4)));
        setProduct(product);
        setMainImage(product.thumbnail);
        console.log(product);


        setQrCodeData({
          "orderProducts": [
            {
              id: "a5b06212-89d5-4065-b8d5-a9c8fed9183c",
              "vendorId": product.vendor_id || null,
              "categoryId": "6873ea91-b0ac-4fad-afee-fa3f13f41849",
              "brandId": null,
              "storeId": null,
              "productId": product.id,
              "machineId": null,
              "machineType": null,
              "vendorName": null,
              "productName": product.title,
              "locationNo": 0,
              "price": product.price,
              "supplyPrice": product.price,
              "productImg": product.thumbnail || "",
              "vendingId": null,
              "quantity": 1,
              "radarImg": "",
              "bannerTextImg": "",
              "liquidImg": "",
              "productDetailImg": product.description || "",
              "productBgImg": ""
            }
          ],
          "amount": product.price,
          "userName": "",
          "storeCode": 5,
          "machineData": "W1swLDFdXQ==",
          "returnUrl": "https://puffuandroid.com/ws/5/mobile/main"
        });

      }
    );

  }, []);
  useEffect(() => {
    if (qrCodeData) {
      console.log(qrCodeData);
      requester.testPaymentRequest(qrCodeData, (result) => {
        console.log(result);
        if (result.code === 0) {
          let ready = result.data;
          requester.payment(ready, (result) => {
            if (result.code === 0) {
              setPaymentResult(result.data);
              dispatch(HistoryReducer.actions.setLoading(false));
              const jsonString = JSON.stringify(result.data);
              if (window.BRIDGE && window.BRIDGE.sendPaymentResult) {
                window.BRIDGE.sendPaymentResult(jsonString);
              }
            }

          });
        } else {
          toast.error("문제가 발생했습니다 관리자에게 문의하세요", {
            autoClose: 1000,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      });
    }
  }, [qrCodeData])

  // 총 금액 계산 함수
  useEffect(() => {
    const total = items.reduce((sum, item) => {
      const variant = product?.variants.find(
        (variant) => variant.id === item.variantId
      );
      const price = variant?.discount_price || variant?.price || 0;
      return sum + price * item.quantity;
    }, 0);
    setTotalPrice(total);
  }, [items, product]);

  const calculateRemainingInventory = (variantId) => {
    const cartItem = cartItems.find(item => item.variant_id === variantId);
    const cartQuantity = cartItem?.quantity || 0;

    const variant = product?.variants?.find(v => v.id === variantId);
    if (!variant) return 0;

    const remainingQuantity = variant.inventory_quantity - cartQuantity;
    return remainingQuantity > 0 ? remainingQuantity : 0;
  };

  const validateInventory = (items) => {
    for (const item of items) {
      const cartItem = cartItems.find(ci => ci.variant_id === item.variantId);
      const cartQuantity = cartItem?.quantity || 0;

      const variant = product.variants.find(v => v.id === item.variantId);
      if (!variant) return false;

      if ((cartQuantity + item.quantity) > variant.inventory_quantity) {
        toast.error(`${variant.title}의 재고가 부족합니다.`, {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        return false;
      }
    }
    return true;
  };

  const resetAllInputs = () => {
    Object.values(inputs.current).forEach(input => {
      if (input && typeof input.setValue === 'function') {
        input.setValue(0);
      }
    });
    setItems([]); // items 상태도 초기화
    setTotalPrice(0); // 총 금액도 초기화
  };


  const handleInputChange = (variantId, value) => {
    setItems((prevItems) => {
      const existingItemIndex = prevItems.findIndex(
        (item) => item.variantId === variantId
      );

      if (existingItemIndex !== -1) {
        // 기존 아이템 업데이트
        if (value === 0) {
          // 수량이 0이면 항목 제거
          return prevItems.filter(item => item.variantId !== variantId);
        }
        const updatedItems = [...prevItems];
        updatedItems[existingItemIndex].quantity = value;
        return updatedItems;
      } else if (value > 0) {
        // 새로운 아이템 추가 (수량이 0보다 클 때만)
        return [...prevItems, { variantId, quantity: value }];
      }
      return prevItems;
    });
  };

  const handleAddToCart = async () => {
    if (!userName) {
      toast.error(t("로그인해주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (items.length === 0) {
      toast.error(t("수량을 선택해주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    // 재고 검증
    if (!validateInventory(items)) {
      return;
    }

    const cartId = getCookie("_medusa_cart_id");
    const cartItems = items.map(item => ({
      variant_id: item.variantId,
      quantity: item.quantity,
      free: false
    }));

    try {
      await storeRequester.addItem(cartId, cartItems);
      toast.success(t("장바구니에 추가되었습니다."), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      // 장바구니 정보 새로고침
      const { cart } = await storeRequester.getMyCart(regionId);
      setCartItems(cart?.items || []);
      resetAllInputs();
    } catch (error) {
      toast.error(t("처리 중 오류가 발생했습니다"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const fetchInterests = () => {
    if (!userName) return;
    storeRequester.getInterest(
      (response) => setInterests(response.interests)
    );
  };

  // 관심 상품 토글 핸들러
  const handleWishToggle = async () => {
    if (!userName) {
      toast.error(t("로그인해주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    try {
      const isWished = interests.some(interest => interest.product_id === product.id);

      if (isWished) {
        // 관심 상품에서 제거
        const interestToDelete = interests.find(
          interest => interest.product_id === product.id
        );
        if (interestToDelete) {
          await storeRequester.delete(`/customers/me/interests/${interestToDelete.id}`);
          // toast.success(t("관심상품에서 제거되었습니다"), {
          //   autoClose: 1000,
          //   position: toast.POSITION.BOTTOM_CENTER,
          // });
        }
      } else {
        // 관심 상품에 추가
        await storeRequester.postInterest({ product_id: product.id });
        // toast.success(t("관심상품에 추가되었습니다"), {
        //   autoClose: 1000,
        //   position: toast.POSITION.BOTTOM_CENTER,
        // });
      }
      // 관심 상품 목록 갱신
      fetchInterests();
    } catch (error) {
      toast.error(t("처리 중 오류가 발생했습니다"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  // 배열을 n개씩 나누는 함수
  const chunkArray = (array, size) => {
    const chunked = [];
    for (let i = 0; i < array.length; i += size) {
      chunked.push(array.slice(i, i + size));
    }
    return chunked;
  };

  const displayPrice = product ? renderPriceInline(product, userName) : '';

  const handleThumbnailHover = (image) => {
    setMainImage(image); // Hover된 썸네일 이미지를 메인 이미지로 설정
  };

  const handleSelectChange = (variant) => {
    // 중복 확인 후 row 추가
    setSelectedRows((prevRows) => {
      if (!prevRows.some((row) => row.id === variant.id)) {
        return [...prevRows, variant];
      }
      return prevRows; // 중복이면 추가하지 않음
    });
  };

  const initializeInputs = useCallback((input, index) => {
    if (input) {
      inputs.current[index] = input;
      // 자동 포커스 방지
      input.blur();
    }
  }, []);

  const PaymentQR = () => {
    if (!paymentResult) {
      return (
        <div className={style.qrWrapper}>
          <div className={`${style.qrPlaceholder} ${isLoading ? style.blur : ''}`}>
            <DummyQr />
          </div>
          <div className={style.qrCornerAnimation}>
            <div className={style.topRightCorner}></div>
            <div className={style.bottomLeftCorner}></div>
          </div>
        </div>
      );
    }

    const deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode ? window.BRIDGE.getDeviceCode() : "";
    const paymentHistoryId = paymentResult && paymentResult.paymentHistoryId;



    return (
      <QRCodeSVG
        value={`http://puffuandroid.com/ws/5/paymentHistory?id=${paymentHistoryId}`}
        size={"200px"}
        bgColor={"#ffffff"}
        fgColor={"#000000"}
        level={"L"}
        includeMargin={false}
      />
    );
  };




  useEffect(() => {
    if (userName) {
      fetchInterests();
    } else {
      setInterests([]);
    }
  }, [userName]);


  return (
    <div className={style.wrap}>
      {product && (
        <Container backgroundColor={"white"} minWidth={1200} maxWidth={1200}>
          <VerticalFlex gap={80}>
            <FlexChild >
              <Container minWidth={1200} maxWidth={1200} borderBottom={'3px solid #ddd'}>
                <HorizontalFlex gap={40} flexStart>
                  <FlexChild width={"max-content"} >
                    <VerticalFlex gap={40}>
                      <FlexChild>
                        <img
                          src={mainImage}
                          alt="Main Product"
                          style={{
                            width: "100%",
                            maxWidth: "380px",
                            minWidth: "380px",
                            borderRadius: "10px",
                          }}
                        />
                      </FlexChild>
                    </VerticalFlex>
                  </FlexChild>
                  <FlexChild>
                    <VerticalFlex gap={17}>
                      <FlexChild >
                        <HorizontalFlex>
                          <FlexChild>
                            <VerticalFlex gap={5}>
                              <FlexChild>
                                <VerticalFlex gap={10}>
                                  <FlexChild>
                                    <Center width={"100%"} textAlign={"left"}>
                                      <P size={18} color={"rgba(196,196,196,1)"} weight={600}>
                                        {product.categories &&
                                          product.categories.length > 0 &&
                                          product.categories?.[0].name}
                                      </P>
                                      <Dummy height={"15px"} />
                                      <P size={24} color={"#444"} weight={700}>
                                        {product.title}
                                      </P>

                                    </Center>
                                  </FlexChild>

                                  <FlexChild>
                                    <HorizontalFlex gap={10} justifyContent={"flex-end"}>
                                      <FlexChild justifyContent={"flex-start"}>
                                        <P
                                          width={isMobile ? "150px" : "100%"}
                                          textAlign={"left"}
                                          size={isMobile ? 16 : 28}
                                          weight={"bold"}
                                          color={"black"}
                                          textDecoration={product.currentPrice && "line-through"}
                                        >
                                          <HighlightedText
                                            text={displayPrice}
                                            highlights={['30ml', '60ml']}
                                            highlightColor="#888"
                                          />
                                        </P>
                                      </FlexChild>
                                    </HorizontalFlex>
                                  </FlexChild>
                                </VerticalFlex>

                              </FlexChild>
                              <FlexChild>
                                <VerticalFlex gap={30}>
                                  <FlexChild padding={"20px 0px 0px 0px"}>
                                    <VerticalFlex gap={20}>
                                      <FlexChild>
                                        {/* <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "20px",
                                          }}
                                        >
                                          {product.variants &&
                                            chunkArray(product.variants, 3).map(
                                              (row, rowIndex) => {
                                                // 부족한 부분을 채울 더미 카드 추가
                                                const filledRow = [
                                                  ...row,
                                                  ...Array(3 - row.length).fill({
                                                    isDummy: true,
                                                  }),
                                                ];

                                                return (
                                                  <div
                                                    key={rowIndex}
                                                    style={{ display: "flex", gap: "20px" }}
                                                  >
                                                    {filledRow.map((variant, index) => (
                                                      <div
                                                        key={index}
                                                        style={{
                                                          flex: "1 1 17%",
                                                          textAlign: "center"
                                                        }}
                                                      >
                                                        {variant.isDummy ? (
                                                          <div />
                                                        ) : (
                                                          <VerticalFlex>
                                                            <FlexChild>
                                                              <div
                                                                style={{
                                                                  position: "relative",
                                                                }}
                                                              >
                                                                <img
                                                                  src={variant.thumbnail}
                                                                  style={{
                                                                    width: "100%",
                                                                    borderRadius: "5px",
                                                                    opacity:
                                                                      (calculateRemainingInventory(variant.id) === 0 ||
                                                                        variant.sold === true)
                                                                        ? 0.2
                                                                        : 1,
                                                                  }}
                                                                />
                                                                {(calculateRemainingInventory(variant.id) === 0 ||
                                                                  variant.sold === true) && (
                                                                    <div
                                                                      style={{
                                                                        position: "absolute",
                                                                        top: "45%",
                                                                        zIndex: 6,
                                                                      }}
                                                                    >
                                                                      <P
                                                                        size={20}
                                                                        weight={700}
                                                                        color={"#ca0000"}
                                                                      >
                                                                        SOLD OUT
                                                                      </P>
                                                                    </div>
                                                                  )}
                                                              </div>
                                                            </FlexChild>
                                                            <FlexChild>
                                                              <Inline>
                                                                <P weight={700} size={14} height={"40px"}>
                                                                  {variant.title}
                                                                </P>
                                                              </Inline>
                                                            </FlexChild>
                                                            <FlexChild>
                                                              <InputNumber
                                                                onChange={(value) => {
                                                                  handleInputChange(
                                                                    variant.id,
                                                                    value
                                                                  );
                                                                  setIsIncrease(
                                                                    !isIncrease
                                                                  );
                                                                }}
                                                                ref={(el) => {
                                                                  if (
                                                                    el &&
                                                                    !variant.isDummy
                                                                  ) {
                                                                    inputs.current[
                                                                      variant.id
                                                                    ] = el;
                                                                  }
                                                                }}
                                                                required={true}
                                                                height={50}
                                                                max={
                                                                  variant.sold
                                                                    ? 0
                                                                    : calculateRemainingInventory(variant.id)
                                                                }
                                                                isAllowed={true}
                                                              />
                                                            </FlexChild>
                                                          </VerticalFlex>
                                                        )}
                                                      </div>
                                                    ))}

                                                  </div>
                                                );
                                              }
                                            )}
                                        </div> */}
                                      </FlexChild>
                                    </VerticalFlex>
                                  </FlexChild>
                                </VerticalFlex>
                              </FlexChild>
                            </VerticalFlex>
                          </FlexChild>
                          <FlexChild width={"40%"}>
                            <VerticalFlex>
                              <FlexChild height={"max-content"}>
                                {/* <P weight={"bold"}>단품 1개 바로 구입!</P> */}
                              </FlexChild>
                              <FlexChild>
                                <PaymentQR />
                              </FlexChild>
                            </VerticalFlex>
                          </FlexChild>
                        </HorizontalFlex>
                      </FlexChild>
                      <FlexChild>
                        <VerticalFlex gap={20}>
                          <FlexChild justifyContent={"flex-end"}>
                            <HorizontalFlex gap={10} justifyContent={"flex-end"}>
                              <FlexChild>
                                {/* <button
                                  onClick={handleWishToggle}
                                  style={{
                                    backgroundColor: "white",
                                    color: "var(--main-color)",
                                    padding: "10px 20px",
                                    border: "1.5px solid var(--main-color)",
                                    borderRadius: "5px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    height: "50px",
                                    width: "95%"
                                  }}
                                >

                                  <FontAwesomeIcon
                                    icon={isProductWished ? faHeartSolid : faHeartRegular}
                                    size={'lg'}
                                    color={isProductWished ? "#ff0000" : "var(--main-color)"}
                                  />
                                  &nbsp;&nbsp;&nbsp;
                                  {isProductWished ? "위시리스트에서 제거" : "위시리스트에 추가"}
                                </button> */}
                              </FlexChild>
                              <FlexChild width={"60%"}>
                                {/* 일괄 담기 버튼 */}
                                {/* <button
                                  className="notranslate"
                                  onClick={() => handleAddToCart()}
                                  style={{
                                    backgroundColor: "var(--main-color)",
                                    color: "#fff",
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "5px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    width: "100%",
                                    height: "50px"
                                  }}
                                >
                                  <img
                                    src={cartIcon}
                                    style={{ color: "white", width: "20px" }}
                                  />{" "}
                                  {userName ? `${addCommas(totalPrice)}` : "-"} 장바구니 담기
                                </button> */}
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                        </VerticalFlex>
                      </FlexChild>
                    </VerticalFlex>
                  </FlexChild>
                </HorizontalFlex>
                <Dummy height={50} />
              </Container>
            </FlexChild>
            <FlexChild>
              <PaddingWrapper padding={"0px 10px"}>
                <Container maxWidth={900}>
                  {// to-do remove
                    product?.content ? (
                      <QuillViewer
                        value={
                          product.content?.startsWith("PHA")
                            ? decode(product.content)
                            : product.content
                        }
                      />
                    ) : (
                      <img
                        src={product.images?.[0]?.url}
                        style={{ width: "100%" }}
                        alt="empty"
                      />
                    )}
                </Container>
              </PaddingWrapper>
            </FlexChild>
          </VerticalFlex >
        </Container >
      )
      }
    </div >
  );
}

export default DeskTopProductDetail3;
